import React from 'react';
import PropTypes from 'prop-types';
import ViPropTypes from '../propTypes';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Badge from '@material-ui/core/Badge';
import {I18n} from 'react-redux-i18n';
import PlayerCameras from '../enum/PlayerCameras';
import DvrTypes from '../enum/DvrTypes';

const camerasOptions = {};

camerasOptions[PlayerCameras.SPLIT_CAMERA] = {
  id: 'playerSwitchCameraSplit',
  icon: 'dashboard',
  translationKey: 'page.playerPage.cameraViews.splitView'
};

camerasOptions[PlayerCameras.FORWARD_CAMERA] = {
  id: 'playerSwitchCameraForward',
  icon: 'arrow_upward',
  translationKey: 'page.playerPage.cameraViews.forwardFacing'
};

camerasOptions[PlayerCameras.DRIVER_CAMERA] = {
  id: 'playerSwitchCameraDriver',
  icon: 'arrow_back',
  translationKey: 'page.playerPage.cameraViews.driver'
};

camerasOptions[PlayerCameras.PASSENGER_CAMERA] = {
  id: 'playerSwitchCameraPassenger',
  icon: 'arrow_forward',
  translationKey: 'page.playerPage.cameraViews.passenger'
};

camerasOptions[PlayerCameras.REAR_CAMERA] = {
  id: 'playerSwitchCameraRear',
  icon: 'arrow_downward',
  translationKey: 'page.playerPage.cameraViews.rear'
};

camerasOptions[PlayerCameras.IN_CABIN_CAMERA] = {
  id: 'playerSwitchCameraDriver',
  icon: 'arrow_downward',
  translationKey: 'page.playerPage.cameraViews.incabin'
};

export default class CameraViewsMenu extends React.Component {
  static propTypes = {
    open: PropTypes.bool,
    machineType: PropTypes.number,
    clips: PropTypes.arrayOf(ViPropTypes.Clip),
    currentCamera: PropTypes.oneOf([
      '',
      ...PlayerCameras.all()
    ]),
    onCameraChange: PropTypes.func
  }

  static defaultProps = {
    machineType: 0,
    clips: [],
    currentCamera: PlayerCameras.SPLIT_CAMERA,
    onCameraChange: () => {}
  }

  state = {
    open: false,
    anchorEl: null
  }

  openMenu = event => {
    this.setState({
      open: true,
      anchorEl: event.currentTarget
    });
  }

  closeMenu = () => {
    this.setState({
      open: false
    });
  }

  changeCamera = cameraView => event => {
    this.props.onCameraChange(cameraView, event);
    this.closeMenu();
  }

  getAvailableCameras() {
    const availableCameras = {
      size: 0,
      cameras: []
    };

    const {clips} = this.props;

    if (!clips) {
      return availableCameras;
    }

    const dvrType = DvrTypes.forMachineType(this.props.machineType);

    PlayerCameras.all(true, this.props.machineType).forEach(cameraName => {
      const channelNumber = dvrType.getChannelNumber(cameraName);

      if (!channelNumber) {
        return;
      }

      const found = clips.some(clip => clip.channel === channelNumber);

      if (!found) {
        return;
      }

      if (cameraName !== PlayerCameras.SPLIT_CAMERA) {
        availableCameras.size+=1;
      }

      availableCameras.cameras.push({
        name: cameraName,
        channel: channelNumber,
        ...camerasOptions[cameraName]
      });
    });

    return availableCameras;
  }

  render() {
    const {currentCamera} = this.props;
    const availableCameras = this.getAvailableCameras();

    return (
      <React.Fragment>
        <IconButton aria-label="Menu" color="inherit" onClick={this.openMenu}>
          <Badge badgeContent={availableCameras.size} className="viappbar__badge-yellow" id="playerSwitchCameras">
            <Icon color="inherit" className="videocamicon">videocam</Icon>
          </Badge>
        </IconButton>
        <Menu
          id="simple-menu"
          className="player__switchcameras"
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.closeMenu}
        >
          {availableCameras.cameras.map(camera =>
            <MenuItem
              id={camera.id}
              key={camera.name}
              selected={camera.name === currentCamera}
              onClick={this.changeCamera(camera.name)}
            >
              <Icon className="viappbar__menuicon">{camera.icon}</Icon>
              {I18n.t(camera.translationKey)}
            </MenuItem>
          )}
        </Menu>
      </React.Fragment>
    );
  }
}
